// Saved map-view bookmarks (Zustand + localStorage). Each bookmark stores the
// full assembled state (center, zoom, projection, active layer, filters, border,
// org, region) so applying it restores an identical view.
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const useBookmarksStore = create(
  persist(
    (set) => ({
      bookmarks: [], // [{ id, name, state }]
      addBookmark: (name, state) => set((s) => ({
        bookmarks: [...s.bookmarks, { id: `${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, name, state }],
      })),
      removeBookmark: (id) => set((s) => ({ bookmarks: s.bookmarks.filter((b) => b.id !== id) })),
      renameBookmark: (id, name) => set((s) => ({
        bookmarks: s.bookmarks.map((b) => (b.id === id ? { ...b, name } : b)),
      })),
    }),
    { name: 'pr-onlinemap-bookmarks' }
  )
)
